import * as React from "react";
import { PageHeading } from "./PageHeading";
import { messages } from "../../utils/i18n/i18n";
import { useTranslation } from "../../utils/i18n/lang";
import { orgRoute, useOrganizationsWhereAdmin } from "../../routes/user";
import { nonEmptyArray, option } from "fp-ts";
import { useAlertOnQueryError } from "../../hooks/useAlertOnQueryError";
import { queryStateData } from "../../utils/supabase/QueryState";
import { useUser } from "../../utils/supabase/useUser";
import { constNull, pipe } from "fp-ts/function";
import {
    Card,
    CardActionArea,
    CardContent,
    Grid,
    Typography,
} from "@mui/material";
import { InternalLink } from "../common/Link";

interface Props {}

export const MyOrganizationsList = (p: Props) => {
    const m = useTranslation(msg);
    const userO = useUser();
    const organizationsWhereAdmin = useOrganizationsWhereAdmin(
        option.isNone(userO)
    );
    useAlertOnQueryError(organizationsWhereAdmin.state);
    // TODO create new organization btn!
    return pipe(
        organizationsWhereAdmin.state,
        queryStateData,
        option.chain(nonEmptyArray.fromArray),
        option.fold(constNull, (organizations) => (
            <>
                <PageHeading heading={m.heading} />
                <Grid container spacing={2} alignItems={"stretch"}>
                    {pipe(
                        organizations,
                        nonEmptyArray.map((org) => (
                            <Grid key={org.id} item md={3}>
                                <Card
                                    sx={{
                                        height: 100,
                                        "&:hover": {
                                            boxShadow: 3,
                                        },
                                    }}
                                >
                                    <InternalLink
                                        href={orgRoute.index.route({
                                            org: org.subdomain,
                                        })}
                                    >
                                        <CardActionArea sx={{ height: 100 }}>
                                            <CardContent>
                                                <Typography
                                                    variant={"subtitle1"}
                                                    fontWeight={"bold"}
                                                >
                                                    {org.name}
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                    </InternalLink>
                                </Card>
                            </Grid>
                        ))
                    )}
                </Grid>
            </>
        ))
    );
};

const msg = messages(
    {
        heading: "My organizations",
    },
    {
        cs: {
            heading: "Moje organizace",
        },
    }
);
